import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function register(state = initialState.register, action) {
    switch(action.type){
        case types.CREATE_USER_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                codeSended: false,
                params: action.params
            })
        case types.CREATE_USER_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: '',
                codeSended: true,
                data: action.data
            })
        case types.CREATE_USER_FAILED:
            return Object.assign({}, state, {
                isFetching: false,
                codeSended: false,
                errorMessage: {
                    ...action.messages
                }
            })
        
        // case types.CREATE_COMPANY_REQUEST:
        //     return Object.assign({}, state, {
        //         isFetching: true,
        //         params: {
        //             ...state.params,
        //             ...action.params
        //         }
        //     })
        // case types.CREATE_COMPANY_SUCCESS:
        //     return Object.assign({}, state, {
        //         isFetching: false,
        //         errorMessage: '',
        //         data: action.data
        //     })
        // case types.CREATE_COMPANY_FAILED:
        //     return Object.assign({}, state, {
        //         isFetching: false,
        //         errorMessage: {
        //             ...action.messages
        //         }
        //     })

        case types.CREATE_USER_VERIFICATION_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                codeSended: false,
                isRegistered: false,
                code: action.code //хотя не нужно отправлять
            })
        case types.CREATE_USER_VERIFICATION_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: '',
                isRegistered: true,
                data: {
                    ...action.data
                }
            })
        case types.CREATE_USER_VERIFICATION_FAILED:
            return Object.assign({}, state, {
                isFetching: false,
                isRegistered: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.PHONE_CONFIRMATION_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                codeSended: false,
                isRegistered: false,
            })
        case types.PHONE_CONFIRMATION_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                isRegistered: false,
                errorMessage: '',
                data: action.data
            })
        case types.PHONE_CONFIRMATION_FAILED:
            return Object.assign({}, state, {
                isFetching: false,
                isRegistered: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.CREATE_USER_CLEAR_MESSAGES:
            return Object.assign({}, state, {
                //isFetching: false,
                errorMessage: ''
            })
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/registerReducer.js